var e="aptos:signMessage";export{e as a};
//# sourceMappingURL=chunk-BIF2XL2R.mjs.map